import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    headerInfo: {
      marginBottom: theme.spacing(2)
    },
    headerCif: {
      color: theme.palette.text.secondary
    },
    tabsWrapper: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginBottom: theme.spacing(2)
    },
    tableWrapper: {
      marginTop: theme.spacing(1)
    }
  })
